import script from "./HomeAdvantages.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeAdvantages.vue?vue&type=script&setup=true&lang=js"

import "./HomeAdvantages.vue?vue&type=style&index=0&id=769a42b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-769a42b6"]])

export default __exports__